import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'TransformBytesToMB'
})
export class TransformBytesToMB implements PipeTransform {
  private static kb = 1024;
  private static sizes = [' Bytes', ' KB', ' MB'];

  transform(bytes: number): string {
    if (bytes === 0) {
      return '';
    }

    const sizePosition = Math.floor(Math.log(bytes) / Math.log(TransformBytesToMB.kb));
    return parseFloat((bytes / Math.pow(TransformBytesToMB.kb, sizePosition)).toFixed(2)) + TransformBytesToMB.sizes[sizePosition];
  }
}
